import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GetPlanUseCase } from './application/use-cases/get-plan/get-plan.use-case';
import { PlanPort } from './domain/ports/plan.port';
import { LealAPIAdapter } from './infrastructure/adapters/leal-api.adapter';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: GetPlanUseCase,
      useFactory: (planPort: PlanPort) => new GetPlanUseCase(planPort),
      deps: [PlanPort],
    },

    { provide: PlanPort, useClass: LealAPIAdapter },
  ],
})
export class PlanModule {}
